export default __webpack_public_path__ + "static/media/09.79e671e6.jpg";